import styles from '@features/thank-you/styles/ThankyouGoVip.module.css';
import React from 'react';
import cn from 'classnames';

import { ImageList } from '@shared/config/constants/Images';
import { useUTMSource } from '@shared/hooks/useUTMSource';
import { windowOpenBlank } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

const footerLinks = [
  { href: 'https://vuz.com/TermsConditionsPrivacyPolicy.html', textKey: 'terms_and_conditions' },
  { href: 'https://vuz.com/360VUZPlatformPolicy.html', textKey: 'platform_policy' },
  { href: 'https://vuz.com/360VUZCommunityGuidelines.html', textKey: 'community_guidelines' },
];

export const ThankyouGoVip = (props) => {
  const { activationURL, showOpenButton = false } = props;
  const { t } = useTranslation();
  const UTMSourceURL = useUTMSource();

  // NOTE: V5 always shows its CTA; showOpenButton additionally requires activationURL when set
  const shouldShowButton = showOpenButton ? Boolean(activationURL) : true;

  const handleRedirect = () => {
    windowOpenBlank(activationURL, UTMSourceURL);
  };

  return (
    <Container className={cn('container-sm', 'mt-1', styles.container)}>
      <div>
        <div className={styles.wrapper}>
          <img src={ImageList.vip_banner_perks_2} alt="VipLogo" className={styles.imageStyle} />
          <div className={styles.centered}>
            <div className={styles.iconAndTitleWrapper}>
              <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="18" r="18" fill="#074DFF" />
                <rect
                  width="25.7143"
                  height="25.7143"
                  transform="translate(5.14258 5.14282)"
                  fill="#074DFF"
                />
                <path
                  d="M24.3514 11.5713L15.0571 20.8713L10.9429 16.7541L9 18.7141L15.0571 24.777L26.3171 13.5141L24.3514 11.5713Z"
                  fill="white"
                />
              </svg>
              <span className={cn(styles.title, 'thankyou_govip_title')}>
                {t('subscription_successful')}
              </span>
            </div>
            <div className={styles.subTitleWrapper}>
              <span className={cn(styles.subTitle, 'thankyou_govip_subtitle')}>
                {t('you_can_now_access')}
              </span>
            </div>
            {shouldShowButton ? (
              <button className={styles.button} onClick={handleRedirect}>
                <span className="thankyou_govip_buttontext">
                  {showOpenButton ? t('open_the_app') : t('buttonText')}
                </span>
              </button>
            ) : null}
          </div>
        </div>
      </div>
      <div className={styles.footerWrapper}>
        <div className={styles.footerContainer}>
          <div className={styles.linkContainer}>
            {footerLinks.map(({ href, textKey }) => {
              return (
                <a key={textKey} href={href}>
                  <span className={cn(styles.link, 'thankyou_govip_footerlink')}>{t(textKey)}</span>
                </a>
              );
            })}
          </div>
          <div className={styles.copyRightWrapper}>
            {['vuz_copyright_1', 'vuz_copyright_2'].map((key) => {
              return (
                <span key={key} className={cn(styles.copyRight, 'thankyou_govip_footercopyright')}>
                  {t(key)}
                </span>
              );
            })}
          </div>
          <img width={'60px'} height={'20px'} src={ImageList.vuz_vip_logo_image} alt="VipLogo" />
        </div>
      </div>
    </Container>
  );
};
